/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiTransactor } from './InternalApiTransactor';
import {
    InternalApiTransactorFromJSON,
    InternalApiTransactorFromJSONTyped,
    InternalApiTransactorToJSON,
    InternalApiTransactorToJSONTyped,
} from './InternalApiTransactor';

/**
 * 
 * @export
 * @interface InternalApiNameCardinalitiesByAccountRequest
 */
export interface InternalApiNameCardinalitiesByAccountRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiNameCardinalitiesByAccountRequest
     */
    accounts: Array<string>;
    /**
     * 
     * @type {InternalApiTransactor}
     * @memberof InternalApiNameCardinalitiesByAccountRequest
     */
    transactorType: InternalApiTransactor;
}



/**
 * Check if a given object implements the InternalApiNameCardinalitiesByAccountRequest interface.
 */
export function instanceOfInternalApiNameCardinalitiesByAccountRequest(value: object): value is InternalApiNameCardinalitiesByAccountRequest {
    if (!('accounts' in value) || value['accounts'] === undefined) return false;
    if (!('transactorType' in value) || value['transactorType'] === undefined) return false;
    return true;
}

export function InternalApiNameCardinalitiesByAccountRequestFromJSON(json: any): InternalApiNameCardinalitiesByAccountRequest {
    return InternalApiNameCardinalitiesByAccountRequestFromJSONTyped(json, false);
}

export function InternalApiNameCardinalitiesByAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiNameCardinalitiesByAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'accounts': json['accounts'],
        'transactorType': InternalApiTransactorFromJSON(json['transactorType']),
    };
}

export function InternalApiNameCardinalitiesByAccountRequestToJSON(json: any): InternalApiNameCardinalitiesByAccountRequest {
    return InternalApiNameCardinalitiesByAccountRequestToJSONTyped(json, false);
}

export function InternalApiNameCardinalitiesByAccountRequestToJSONTyped(value?: InternalApiNameCardinalitiesByAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accounts': value['accounts'],
        'transactorType': InternalApiTransactorToJSON(value['transactorType']),
    };
}

